import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance"

export const getMainData = () => {
    return axiosPrivate.get(`/bills/api/v1/dashboard-main-data/`)
}